import styles from "./CheatSheet.module.css";
import { GLOBAL_KEYS } from "../chrome/keymap";
import { Kbd } from "../components/Kbd";
import { Modal } from "../components/Modal";

type Group = {
  readonly keys: ReadonlyArray<readonly [string, string]>;
  readonly title: string;
};

// The Global group is derived from the same GLOBAL_KEYS table useGlobalKeys
// fires from, so every real shortcut (incl. the G-chords) is documented and the
// two can't drift. Esc is modal-handled (not a global binding), appended here.
const GLOBAL_GROUP: Group = {
  keys: [
    ...GLOBAL_KEYS.map((b) => [b.display, b.label] as const),
    ["Esc", "Close / dismiss"],
  ],
  title: "Global",
};

// Context-specific shortcuts, handled locally where they apply (not global key
// bindings) — documented here for completeness.
const EXTRA_GROUPS: ReadonlyArray<Group> = [
  {
    keys: [
      ["Enter", "Send message"],
      ["Shift + Enter", "New line"],
    ],
    title: "Task · chat",
  },
  {
    keys: [
      ["Click card", "Open task"],
      ["Kanban / List", "Toggle layout"],
    ],
    title: "Board",
  },
];

const GROUPS: ReadonlyArray<Group> = [GLOBAL_GROUP, ...EXTRA_GROUPS];

export type CheatSheetProps = {
  readonly onClose: () => void;
};

export const CheatSheet = ({ onClose }: CheatSheetProps) => (
  <Modal
    className={styles.cheat}
    onClose={onClose}
    open
    title="Keyboard shortcuts"
  >
    <div className={styles.head}>
      <span className={styles.title}>Keyboard</span>
      <span className={styles.grow} />
      <Kbd>Esc</Kbd>
    </div>
    <div className={styles.grid}>
      {GROUPS.map((g) => (
        <div key={g.title}>
          <div className={styles.groupTitle}>{g.title}</div>
          {g.keys.map(([key, desc]) => (
            <div className={styles.row} key={key}>
              <Kbd>{key}</Kbd>
              <span className={styles.desc}>{desc}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </Modal>
);
